import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgxBootstrapIconsModule } from 'ngx-bootstrap-icons';

import { CustomNutritionGoalsComponent } from './custom-nutrition-goals.component';
import { CustomNutritionGoalsEditorModule } from './modal/custom-nutrition-goals-editor/custom-nutrition-goals-editor.module';

@NgModule({
  declarations: [CustomNutritionGoalsComponent],
  imports: [
    CommonModule,
    NgxBootstrapIconsModule,
    ProgressbarModule,
    TooltipModule,
    CustomNutritionGoalsEditorModule,
  ],
  exports: [CustomNutritionGoalsComponent],
})
export class CustomNutritionGoalsModule {}
